import * as L from 'leaflet';

export interface ToolbarModes {
  rectangle: { handler: L.Draw.Rectangle };
  circle: { handler: L.Draw.Circle };
  polygon: { handler: L.Draw.Polygon };
  polyline: { handler: L.Draw.Polyline };
  marker: { handler: L.Draw.Marker };
}

export interface Toolbar {
  _modes: ToolbarModes;
}

export interface ToolbarControl {
  draw: Toolbar;
}

export class LeafletDrawWrapper {

  private leafletDraw: L.Control.Draw;

  public currentHandler: L.Handler;

  public rectangleHandler: L.Draw.Rectangle;
  public circleHandler: L.Draw.Circle;
  public polygonHandler: L.Draw.Polygon;
  public polylineHandler: L.Draw.Polyline;
  public markerHandler: L.Draw.Marker;


  constructor(leafletDraw: L.Control.Draw, hideExistingToolbar: boolean = false) {
    this.leafletDraw = leafletDraw;

    let toolbarControl: ToolbarControl = this.leafletDraw['_toolbars'];

    this.rectangleHandler = toolbarControl.draw._modes.rectangle.handler;
    this.circleHandler = toolbarControl.draw._modes.circle.handler;
    this.polygonHandler = toolbarControl.draw._modes.polygon.handler;
    this.polylineHandler = toolbarControl.draw._modes.polyline.handler;
    this.markerHandler = toolbarControl.draw._modes.marker.handler;

    if (hideExistingToolbar) {
      this.leafletDraw.getContainer().style.display = "none";
    }
  }

  drawRectangle() {
    this.cancel();
    if (!this.currentHandler) {
      this.currentHandler = this.rectangleHandler;
      this.enableHandler();
    }
  }

  drawCircle() {
    this.cancel();
    if (!this.currentHandler) {
      this.currentHandler = this.circleHandler;
      this.enableHandler();
    }
  }

  drawPolygon() {
    this.cancel();
    if (!this.currentHandler) {
      this.currentHandler = this.polygonHandler;
      this.enableHandler();
    }
  }

  drawPolyline() {
    this.cancel();
    if (!this.currentHandler) {
      this.currentHandler = this.polylineHandler;
      this.enableHandler();
    }
  }

  drawMarker() {
    this.cancel();
    if (!this.currentHandler) {
      this.currentHandler = this.markerHandler;
      this.enableHandler();
    }
  }

  private enableHandler() {
    if (this.currentHandler) {
      this.currentHandler.enable();
    }
  }

  cancel() {
    this.rectangleHandler.disable();
    this.circleHandler.disable();
    this.polygonHandler.disable();
    this.polylineHandler.disable();
    this.markerHandler.disable();
    this.currentHandler = null;
  }

}
